import type { FC } from "react";

import HooksModalV2Key from "app/constants/HooksModalV2Key";
import { openHooksModalV5 } from "app/services/ModalService";

import FeatureUpgradeBanner from "../components/FeatureUpgradeBanner/FeatureUpgradeBanner";

const InternationalVisitsUpgradeBanner: FC = () => {
    const TEXT_KEYS = {
        contentHook: "si.lead_gen_filters.group.international_visits.tooltip.disabled.secondary",
        headerHook: "si.lead_gen_filters.group.international_visits.hook.header",
        buttonHook: "si.lead_gen_filters.group.international_visits.button.hook",
    };

    return (
        <FeatureUpgradeBanner
            titleKey={TEXT_KEYS.headerHook}
            subtitleKey={TEXT_KEYS.contentHook}
            buttonTextKey={TEXT_KEYS.buttonHook}
            onSubmit={() => openHooksModalV5(HooksModalV2Key.WebCountry)}
            withSuccessView={false}
        />
    );
};

export default InternationalVisitsUpgradeBanner;
